import { Phone, PhoneCall, MessageSquare, Mic } from 'lucide-react';
import { Badge } from '@shared/components/ui/badge';
import { cn } from '@shared/lib/utils';

/** Origin channel a conversation/question/handoff came through (V — visibility). */
export type Channel = 'web' | 'voice' | 'phone' | 'web_voice';

const CHANNEL_CONFIG: Record<
  Channel,
  { label: string; icon: typeof Phone; className: string }
> = {
  web: {
    label: 'Chat',
    icon: MessageSquare,
    className: 'border-slate-200 text-slate-600 bg-slate-50',
  },
  voice: {
    label: 'Voice',
    icon: Phone,
    className: 'border-violet-200 text-violet-700 bg-violet-50',
  },
  // Orlenn phone numbers (Twilio). `voice` stays Vapi web voice / Vapi numbers.
  phone: {
    label: 'Phone',
    icon: PhoneCall,
    className: 'border-teal-200 text-teal-700 bg-teal-50',
  },
  // Native web voice (4.1/4.2): the widget's voice button on Orlenn's engine.
  web_voice: {
    label: 'Web voice',
    icon: Mic,
    className: 'border-indigo-200 text-indigo-700 bg-indigo-50',
  },
};

/** Small pill identifying whether a row/record came from chat (web), voice or phone. */
export function ChannelBadge({
  channel,
  className,
}: {
  channel: Channel;
  className?: string;
}) {
  // Unknown values (newer API) fall back to the chat pill instead of crashing.
  const config = CHANNEL_CONFIG[channel] ?? CHANNEL_CONFIG.web;
  const Icon = config.icon;
  return (
    <Badge
      variant="outline"
      className={cn('gap-1 font-medium', config.className, className)}
    >
      <Icon className="h-3 w-3" />
      {config.label}
    </Badge>
  );
}
